import getFormatMessage from '../../../locales/get-format-message';
import { CommonStatusStep } from '../../../model/api-modules';

export const getStatusText = (
  status: CommonStatusStep,
  isWhite = false
): string => {
  switch (status) {
    case CommonStatusStep.Pending:
      return getFormatMessage('common_status_step_pending');
    case CommonStatusStep.Resolve:
      return isWhite
        ? getFormatMessage('common_status_step_partly')
        : getFormatMessage('common_status_step_active');
    case CommonStatusStep.Reject:
      return getFormatMessage('common_status_step_expired');
    default:
      return '-';
  }
};
